/** Mirrors SqlDataLayer/Enums/PushNotificationEnums.cs -> PushNotificationAudience. */
export enum ENotificationAudience {
  AllUsers = "AllUsers",
  SelectedLocations = "SelectedLocations",
  SelfOnly = "SelfOnly",
  SelectedUsers = "SelectedUsers",
}

/** Mirrors SqlDataLayer/Enums/PushNotificationEnums.cs -> PushNotificationType. */
export enum ENotificationType {
  General = "General",
  NewExercise = "NewExercise",
  NewWorkout = "NewWorkout",
}

/** Max lengths enforced by SendGeneralNotificationRequestValidator on the backend. */
export const NOTIFICATION_TITLE_MAX_LENGTH = 65;
export const NOTIFICATION_BODY_MAX_LENGTH = 200;

export interface ISendGeneralNotificationRequest {
  title: string;
  body: string;
  audience: ENotificationAudience;
  locationIds: string[];
  userIds: string[];
}

/** A user that can be picked as the recipient of a Selected users announcement. */
export interface INotificationRecipient {
  id: string;
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  organizationName: string;
  locationNames: string[];
  /** 0 means the user will only ever see the announcement in the in-app list. */
  deviceCount: number;
}

export interface INotificationRecipientsResponse {
  items: INotificationRecipient[];
  page: number;
  pageSize: number;
  totalCount: number;
}

export interface ISendNotificationResponse {
  notificationLogId: string;
  targetUserCount: number;
  deviceCount: number;
  successCount: number;
  failureCount: number;
  errorSummary: string;
}

export interface INotificationHistoryItem {
  id: string;
  type: ENotificationType;
  title: string;
  body: string;
  audienceDescription: string;
  targetUserCount: number;
  deviceCount: number;
  successCount: number;
  failureCount: number;
  errorSummary: string;
  createdAt: string;
}

export interface INotificationHistoryResponse {
  items: INotificationHistoryItem[];
  page: number;
  pageSize: number;
  totalCount: number;
}
